<div class="breadcrumbs" [ngClass]="{'breadcrumbs-hidden': (breadcrumbs.length || 0) <= 1}">

    @for(item of breadcrumbs; track item; let i = $index) {
        <div class="breadcrumb-item navigate-item" (click)="item.navigateToUrl ? navigate(item.navigateToUrl) : null"
            [class.disabled]="!item.navigateToUrl">
            <h6 class="text-koala-gray">{{item.name}}</h6>
        </div>
        @if(i < breadcrumbs.length - 1) {
            <span class="mso sm">arrow_forward_ios</span>
        }
    }

</div>